
export interface ColorPalette {
  light: string;
  main: string;
  dark: string;
}

export const themeColorAppJs = {
  red: {
    light: "#FFEBEE",
    main: "#F44336",
    dark: "#D32F2F",
  },

  green: {
    light: "#5de41f2c",
    main: "#4CAF50",
    dark: "#3CA404",
  },
  
  orange: {
    light: "#FFECB3",
    main: "#FF9800",
    dark: "#F57C00",
  },

  gray:{
    light: "#FAFAFA",
    main: "#E0E0E0",
    dark: "#BDBDBD",
  },

  blue:{
    light: "#E3F2FD",
    main: "#2196F3",
    dark: "#1976D2",
  }
};
